import config from '../config.json'
import { UserManager, WebStorageStateStore } from 'oidc-client-ts'

const backendName = process.env.VUE_APP_BACKEND
  ? process.env.VUE_APP_BACKEND
  : 'local'

// we export it because we use it in vuex
export const createUserManager = (redirectUri = '') => {
  return new UserManager({
    ...config.keycloak[backendName].clientConfig,
    redirect_uri: redirectUri,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
  })
}

const updatePassword = () => {
  window.location.replace(
    `${config.keycloak[backendName].host}:${config.keycloak[backendName].options.port}/realms/omniscient/protocol/openid-connect/auth?response_type=code&client_id=omniscient&kc_action=UPDATE_PASSWORD`,
  )
}

const logout = async () => {
  try {
    const frontURL = `?post_logout_redirect_uri=${window.location.href
      .split('/')
      .slice(0, 3)
      .join('/')}/`
    window.location.replace(
      `${config.keycloak[backendName].host}:${config.keycloak[backendName].options.port}/realms/omniscient/protocol/openid-connect/logout${frontURL}`,
      { withCredentials: true },
    )
  } catch (e) {
    console.log(e.message)
  }
}

const keycloak = {
  createUserManager,
  updatePasswordRedirection: updatePassword,
  logoutRedirection: logout,
  userManager: null,
}

const VueKeycloak = {
  install(Vue, _options) {
    Vue.prototype.$keycloak = keycloak
  },
}
export default VueKeycloak
